import { DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export type TournamentGetListRequest = GetListRequest<TournamentGetListRequestFilter>;
export type TournamentGetListResponse = GetListResponse<Tournament>;
export type TournamentDeleteRequest = DeleteRequest;

export interface TournamentGetListRequestFilter {
  /** @format int64 */
  refOrganization_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
}

export interface Tournament {
  /** @format int64 */
  refOrganization_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;

  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
}

export interface TournamentInsertRequest {
  /** @format int64 */
  refOrganization_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
  tournament_Translations: TournamentTranslationInsertRequest[];
}

export interface TournamentTranslationInsertRequest {
  translation?: string | null;
  name?: string | null;
  description?: string | null;
  tags?: string | null;

  /** @format int64 */
  refLanguage_Id?: number | null;
  isEnabled?: boolean | null;
}
